module.exports = __webpack_public_path__ + "static/header_bg-59c843e193362cfb68cb0fbff3e48c88.png";